import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Missing Demographic Information", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "small striped toggle no-underline vertical-align-start mt-30" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "" }, [
    /*#__PURE__*/_createElementVNode("th", null, "NBF ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Member Name"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("Most Recent Employer/ "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Production")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "D.O.B"),
    /*#__PURE__*/_createElementVNode("th", null, "Gender"),
    /*#__PURE__*/_createElementVNode("th", null, "Address")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "plan-modal"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "d-flex gap-30 flex-column" }
const _hoisted_11 = { class: "d-flex gap-80 w-100" }
const _hoisted_12 = { class: "d-flex flex-column gap-30 w-100" }
const _hoisted_13 = { class: "d-flex flex-column gap-30 w-100" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, " Currently, there are no employees who require demographic data updates. ")
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      errors: $setup.errors,
      info: $setup.info,
      success: $setup.success
    }, null, 8, ["errors", "info", "success"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_MessageCard, {
        message: "The Fund office is in receipt of employer contributions on behalf of the following participant(s) in your work jurisdiction. However, vital demographic information is missing. Please provide the information by correcting/adding data through the form that opens when you click the “Update” button. In the event you are unable to identify the participant by the information provided, please contact the Participant Services Center at PSC@iatsenbf.org.",
        type: "primary",
        iconClass: "iatse-icon-alarm",
        classes: "info_card__page"
      }),
      ($setup.loading)
        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              ($setup.data.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data, (person) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "large",
                        key: person.PersonID
                      }, [
                        _createElementVNode("td", null, [
                          ($setup.isLocal)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "javascript;",
                                class: "plan-modal",
                                onClick: _withModifiers(($event: any) => ($setup.openModal('local-member-profile', 'Member Profile', 'plan-profile plan-tables profile', null, { PersonID: person.PersonID })), ["prevent"])
                              }, _toDisplayString(person.PersonID), 9, _hoisted_7))
                            : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(person.PersonID), 1))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(person.Name), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(person.Employer) + " ", 1),
                          _hoisted_9,
                          _createTextVNode(" " + _toDisplayString(person.Production), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(person.DateofBirth ?? '--'), 1),
                        _createElementVNode("td", null, _toDisplayString(person.Sex ?? '--'), 1),
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("p", null, " Street 1: " + _toDisplayString(person.Street1 ?? '--'), 1),
                              _createElementVNode("p", null, " City: " + _toDisplayString(person.City ?? '--'), 1),
                              _createElementVNode("p", null, " Postal Code: " + _toDisplayString($setup.formatZipCode(person.ZipCode)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("p", null, " Street 2: " + _toDisplayString(person.Street2 ?? '--'), 1),
                              _createElementVNode("p", null, " State: " + _toDisplayString(person.State ?? '--'), 1),
                              _createElementVNode("p", null, " Country: " + _toDisplayString(person.Country ?? '--'), 1)
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary border-radius-8 w-fit lh-1 align-self-end plan-modal",
                            onClick: ($event: any) => ($setup.openModal('user-edit-demographics', 'Missing Demographics Information', 'plan-upload plan-card-info plan-profile-update', null, { PersonID: person.PersonID }))
                          }, " Update ", 8, _hoisted_14)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_15, _hoisted_17))
            ])
          ]))
    ])
  ], 64))
}